import { cx } from '../styles/theme';
import { LEVEL_CLASSES } from '../utils/heatmap';

/** Less ▢▢▢▢▢ More — the intensity key for the project activity heatmap. */
export function HeatmapLegend({ className }: { className?: string }) {
  return (
    <div className={cx('flex items-center gap-1.5 text-[10px] text-navy-400 dark:text-navy-500', className)}>
      <span>Less</span>
      <div className="flex items-center gap-0.5">
        {LEVEL_CLASSES.map((cls, i) => (
          <span key={i} className={cx('h-2.5 w-2.5 rounded-sm', cls)} />
        ))}
      </div>
      <span>More</span>
    </div>
  );
}
